export const red = '#E50000';
export const green = '#00B900';
export const blue = '#0090E3';
export const gray = '#999999';
export const antarcticblue = '#CCE9F9';
export const peppermint = '#E0F6E0';

export default {red, green, blue, gray, antarcticblue, peppermint};